import { Popover } from "antd";
import { useTranslation } from "react-i18next";
import { useEnumeration } from "../../../../../../common/api/queries";
import {
  createCommissionsSettingsLevelChain,
  formatCommissionsLevelName,
} from "../../../../../commissions/level/utils";
import { EnumerationType } from "../../../../../enumerations/enums";
import { DashboardGoal } from "../../../../types";
import { GoalCard } from "../cards/GoalCard";

type Props = {
  goal: DashboardGoal;
  year: number;
  agentId: string;
};

export const BrokerLevelWrapper = ({ goal, agentId, year }: Props) => {
  const { t } = useTranslation();

  const commissionsSettingsLevelsEnums = useEnumeration(EnumerationType.COMMISSIONS_SETTINGS_LEVELS);

  const levelChain = goal.actualCommissionsLevel
    ? createCommissionsSettingsLevelChain(commissionsSettingsLevelsEnums, goal.actualCommissionsLevel.id).filter(
        (option) => option.id !== goal.actualCommissionsLevel?.id,
      )
    : commissionsSettingsLevelsEnums;

  return (
    <GoalCard
      goal={goal}
      agentId={agentId}
      year={year}
      percentage={levelChain.find((level) => level.id === goal.targetCommissionsLevel?.id) ? 0 : 100}
      label={
        <Popover content={t("dashboard.goals.helpers.levelGoalHint")}>
          {t("dashboard.enums.dashboardGoalType.BROKER_LEVEL")}
        </Popover>
      }
      tooltipTitle={
        <div>
          <div>
            {t("dashboard.goals.helpers.currentLevel")}:{" "}
            {goal.actualCommissionsLevel ? (
              formatCommissionsLevelName(goal.actualCommissionsLevel)
            ) : (
              <span className="sub-header-info dashed">{t("common.none")}</span>
            )}
          </div>
          <div>
            {t("dashboard.goals.helpers.targetLevel")}: {formatCommissionsLevelName(goal.targetCommissionsLevel)}
          </div>
        </div>
      }
      hasTarget
    />
  );
};
